import React from 'react';

interface ZeraPartnersProps {
  bg?: string;
}

const PARTNERS_IMAGE =
  'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1779980119474_36ec9303.png';

const ZeraPartners: React.FC<ZeraPartnersProps> = ({ bg = '#FAF8F3' }) => {
  return (
    <section
      aria-labelledby="zera-partners-heading"
      className="py-20 lg:py-28"
      style={{ backgroundColor: bg }}
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-12 lg:mb-16">
          <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961] block mb-4">
            Trusted Affiliations
          </span>
          <h2
            id="zera-partners-heading"
            className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1A3B5C] font-light gold-underline"
          >
            Zera Partners
          </h2>
          <p className="font-sans text-sm text-[#777] max-w-xl mx-auto leading-relaxed mt-10">
            Proud members and preferred partners of the world's most prestigious
            hospitality consortia and luxury hotel collections.
          </p>
        </div>

        <div className="flex justify-center">
          <img
            src={PARTNERS_IMAGE}
            alt="Zera Partners: Four Seasons Preferred Partner, Small Luxury Hotels of the World, Belmond Bellini Club, Rosewood Elite, The Leading Hotels of the World, Virtuoso Member, Rocco Forte Knights, Relais & Châteaux, Diamond Club Dorchester Collection, The Peninsula PenClub, Aman, and IHG Hotels & Resorts"
            className="w-full max-w-5xl h-auto object-contain"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default ZeraPartners;
